export default __webpack_public_path__ + "static/media/audi.84b0f62d.svg";